import type { Mention } from "../../../api/threads/liveMessages";

/**
 * The Thread entries `<thread id>#<number>` a message being written refers to (threads.md
 * T-13) and the tools it gives the agent (W2-6), sent with it so the server checks them. A
 * message is always to the agent and names no people (F70): people take part through the
 * Workflow's person steps. What the composer suggests while typing is `suggestions.ts`.
 */

const ENTRY_REFERENCE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}#[1-9][0-9]*/gi;

/** A tool version picked into the message: the agent's turn may run it (W2-6). */
export interface PickedTool {
  readonly reference: string;
  readonly name: string;
}

/** The mentions to send with `text`: every entry reference, and every picked tool whose reference is still in the text, each once. */
export function mentionsOf(text: string, pickedTools: readonly PickedTool[] = []): Mention[] {
  const entries = new Set((text.match(ENTRY_REFERENCE) ?? []).map((reference) => reference.toLowerCase()));
  const mentions: Mention[] = [...entries].map((entry) => ({ kind: "entry", entry }));
  for (const reference of new Set(toolsStillIn(text, pickedTools).map((tool) => tool.reference))) {
    mentions.push({ kind: "tool", tool: reference });
  }
  return mentions;
}

/** The picked tools whose reference the text still holds, each once. */
export function toolsStillIn(text: string, pickedTools: readonly PickedTool[]): PickedTool[] {
  const seen = new Set<string>();
  return pickedTools.filter((tool) => {
    if (seen.has(tool.reference) || !text.includes(tool.reference)) return false;
    seen.add(tool.reference);
    return true;
  });
}
